import { render, staticRenderFns } from "./AmenityItem.vue?vue&type=template&id=6deb9dd6&scoped=true&"
import script from "./AmenityItem.vue?vue&type=script&lang=js&"
export * from "./AmenityItem.vue?vue&type=script&lang=js&"
import style0 from "./AmenityItem.vue?vue&type=style&index=0&id=6deb9dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deb9dd6",
  null
  
)

export default component.exports